<template lang="pug">
    .box
        v-server-table(
            :url='""'
            :name='tableName'
            ref='datatable'
            :columns='columns'
            :options='options'
        )
            template(slot='beforeTable')
                datatable-loader(:name='tableName')

            template(slot="afterTable")
                es-table-pagination(
                    ref="nav"
                    :count="count"
                    :totalRecords="totalRecords"
                    :isLoading="isLoading"
                    @limit-change="setLimit"
                    @navigate="setAfterKey"
                )
</template>

<script>
const TableName = 'VUETABLE_RETURNED_ITEMS_ES';

import { mapState } from 'vuex';
import receiptMixin from '@js/mixins/receipt';
import tillFilterMixin from '../../../components/till-filter/till-filter-mixin';

export default {
    mixins: [receiptMixin, tillFilterMixin],

    data() {
        let columns = [
            'returned_at',
            'settled_date',
            'receipt_number',
            'returner',
            'reason',
            'till_closure',
            'till_summary',
            'cashier',
            'payment_type',
            'name',
            'quantity',
            'total_amount',
            'outlet_name',
        ];

        return {
            tableName: TableName,
            afterKey: null,
            count: 0,
            isLoading: true,
            totalRecords: 0,
            columns,
            options: {
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                sortable: ['settled_date'],
                footer: false,
                headings: {
                    receipt_number: 'Receipt No.',
                    settled_date: 'Receipt Date',
                    returner: 'Returned By',
                    returned_at: 'Returned At',
                    outlet_name: this.trans('general.outlet'),
                    total_amount: 'Total Amount (RM)',
                    payment_type: 'Payment Type',
                    till_closure: 'Till Closure No.',
                    till_summary: 'Till Summary No.',
                    name: 'Product Name',
                },
                texts: {
                    title: 'Returned Items',
                    description: 'Shows list of returned items',
                },
                columnsClasses: {
                    total_amount: 'text-right',
                    quantity: 'text-right',
                },
                templates: {
                    receipt_number: (h, row, col) => {
                        return this.receiptNumberFormat(row);
                    },

                    returned_at: (h, row, col) => {
                        return this.receiptDateFormat(row.returned_at);
                    },
                    // reason(h, row) {
                    //     return require('./void-remarks')(h, row);
                    // },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    outlet_name: (h, row) => {
                        return row.outlet_name.substring(0, 20);
                    },
                },
                orderBy: {
                    column: 'settled_date',
                    ascending: 0,
                },
                responseAdapter: resp => {
                    this.totalRecords = resp.data.count;
                    return resp.data;
                },
                requestFunction: async data => {
                    if (data.afterKey && data.afterKey === this.afterKey) {
                        data.afterKey = null;
                        this.resetPagination();
                    }

                    try {
                        const response = await axios.get(
                            Laroute.route(
                                'franchise.report.voidedsales.es.returnedItemList',
                            ),
                            {
                                params: data,
                            },
                        );

                        this.$refs.nav.afterKey = response.data.afterKey;

                        return response;
                    } catch (e) {
                        this.dispatch('error', e);
                    }
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.es.returnedItemExport',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.es.returnedItemExport',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.es.returnedItemExport',
                    { type: 'XLSX' },
                ),
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        getActiveOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },

        getActiveOutlet() {
            this.setColumnDisplay();
        },
    },

    mounted() {
        this.setColumnDisplay();

        this.$watch(
            () => this.$refs.datatable.tableData.length,
            data => {
                this.count = data;
            },
        );

        this.createVuexSubscription(`${TableName}/LOADING`, () => {
            this.isLoading = true;
        });

        this.createVuexSubscription(`${TableName}/LOADED`, () => {
            this.isLoading = false;
        });

        this.createVuexSubscription(`${TableName}/ERROR`, () => {
            this.isLoading = false;
        });
    },

    methods: {
        setLimit(limit) {
            this.$refs.datatable.setLimit(limit);
        },

        setAfterKey(afterKey) {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'afterKey',
                value: afterKey,
            });

            this.afterKey = afterKey;
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        resetPagination() {
            this.$refs.nav.$emit('reset-es-pagination');
        },

        setColumnDisplay() {
            if (this.getActiveOutlet != 0) {
                this.$refs.datatable.userControlsColumns = true;
                this.$refs.datatable.userColumnsDisplay = [
                    'returned_at',
                    'settled_date',
                    'receipt_number',
                    'returner',
                    'reason',
                    'till_closure',
                    'till_summary',
                    'name',
                    'quantity',
                    'cashier',
                    'payment_type',
                    'total_amount',
                ];
            } else {
                this.$refs.datatable.userColumnsDisplay = this.columns;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/es-report/returned-item-datatable.vue